"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));

var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));

var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));

var _swiper = _interopRequireWildcard(require("swiper"));

var _react2 = require("swiper/react");

require("swiper/swiper-bundle.min.css");

var _styles = require("@material-ui/core/styles");

var _styles2 = require("./styles");

var _theme = _interopRequireDefault(require("../theme"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // install Swiper modules


_swiper.default.use([_swiper.Navigation, _swiper.Pagination, _swiper.Scrollbar, _swiper.A11y, _swiper.Keyboard, _swiper.Mousewheel, _swiper.Zoom, _swiper.Lazy]);

var sliderBreakpoints = {
  // when window width is >= 320px
  320: {
    slidesPerView: 1,
    spaceBetween: 10
  },
  // when window width is >= 768px
  768: {
    slidesPerView: 1,
    spaceBetween: 10
  }
};

var Swiper = function Swiper(props) {
  var _props$a11y = props.a11y,
      a11y = _props$a11y === void 0 ? true : _props$a11y,
      _props$breakpoints = props.breakpoints,
      breakpoints = _props$breakpoints === void 0 ? sliderBreakpoints : _props$breakpoints,
      _props$centeredSlides = props.centeredSlides,
      centeredSlides = _props$centeredSlides === void 0 ? false : _props$centeredSlides,
      _props$centerInsuffic = props.centerInsufficientSlides,
      centerInsufficientSlides = _props$centerInsuffic === void 0 ? false : _props$centerInsuffic,
      _props$keyboard = props.keyboard,
      keyboard = _props$keyboard === void 0 ? true : _props$keyboard,
      _props$lazy = props.lazy,
      lazy = _props$lazy === void 0 ? true : _props$lazy,
      _props$navigation = props.navigation,
      navigation = _props$navigation === void 0 ? {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  } : _props$navigation,
      _props$noSwiping = props.noSwiping,
      noSwiping = _props$noSwiping === void 0 ? false : _props$noSwiping,
      _props$preloadImages = props.preloadImages,
      preloadImages = _props$preloadImages === void 0 ? true : _props$preloadImages,
      _props$slidesPerView = props.slidesPerView,
      slidesPerView = _props$slidesPerView === void 0 ? 1 : _props$slidesPerView,
      _props$spaceBetween = props.spaceBetween,
      spaceBetween = _props$spaceBetween === void 0 ? 10 : _props$spaceBetween,
      _props$speed = props.speed,
      speed = _props$speed === void 0 ? 150 : _props$speed,
      _props$tag = props.tag,
      tag = _props$tag === void 0 ? 'section' : _props$tag,
      _props$wrapperTag = props.wrapperTag,
      wrapperTag = _props$wrapperTag === void 0 ? 'ul' : _props$wrapperTag,
      _props$slides = props.slides,
      slides = _props$slides === void 0 ? [] : _props$slides,
      _props$children = props.children,
      children = _props$children === void 0 ? undefined : _props$children;
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: _theme.default
  }, /*#__PURE__*/_react.default.createElement(_CssBaseline.default, null), /*#__PURE__*/_react.default.createElement(_styles2.StyledSwiper, {
    className: "swiper-no-swiping"
  }, /*#__PURE__*/_react.default.createElement(_react2.Swiper, {
    a11y: a11y,
    breakpoints: breakpoints,
    centeredSlides: centeredSlides,
    centerInsufficientSlides: centerInsufficientSlides,
    keyboard: keyboard,
    lazy: lazy,
    navigation: navigation,
    noSwiping: noSwiping,
    preloadImages: preloadImages,
    slidesPerView: slidesPerView,
    spaceBetween: spaceBetween,
    speed: speed,
    tag: tag,
    wrapperTag: wrapperTag,
    slides: slides
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "swiper-button-prev",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_KeyboardArrowLeft.default, {
    style: {
      fontSize: 40
    }
  })), /*#__PURE__*/_react.default.createElement("button", {
    className: "swiper-button-next",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_KeyboardArrowRight.default, {
    style: {
      fontSize: 40
    }
  })), slides.map(function (slide) {
    return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
      key: slide.key,
      tag: "li",
      zoom: true
    }, slide);
  }), children)));
};

Swiper.propTypes = {
  a11y: _propTypes.default.bool,
  breakpoints: _propTypes.default.object,
  centeredSlides: _propTypes.default.bool,
  centerInsufficientSlides: _propTypes.default.bool,
  keyboard: _propTypes.default.bool,
  lazy: _propTypes.default.bool,
  navigation: _propTypes.default.shape({
    nextEl: _propTypes.default.string,
    prevEl: _propTypes.default.string
  }),
  noSwiping: _propTypes.default.bool,
  preloadImages: _propTypes.default.bool,
  slidesPerView: _propTypes.default.number,
  spaceBetween: _propTypes.default.number,
  speed: _propTypes.default.number,
  tag: _propTypes.default.string,
  wrapperTag: _propTypes.default.string,
  slides: _propTypes.default.arrayOf(_propTypes.default.node),
  children: _propTypes.default.node
};
var _default = Swiper;
exports.default = _default;